// src/useField.tsx
import React, { useState } from "react";
import { useStore } from "@tanstack/react-store";
import { FieldApi, functionalUpdate } from "@tanstack/form-core";
import { useFormContext, formContext } from "./formContext.js";
import useIsomorphicLayoutEffect from "use-isomorphic-layout-effect";
function useField(opts) {
  const { formApi, parentFieldName } = useFormContext();
  const [fieldApi] = useState(() => {
    const name = (typeof opts.index === "number" ? [parentFieldName, opts.index, opts.name] : [parentFieldName, opts.name]).filter((d) => d !== void 0).join(".");
    const api = new FieldApi({
      ...opts,
      form: formApi,
      // TODO: Fix typings to include `index` and `parentFieldName`, if present
      name
    });
    api.Field = Field;
    return api;
  });
  useIsomorphicLayoutEffect(() => {
    fieldApi.update({ ...opts, form: formApi });
  });
  useStore(
    fieldApi.store,
    opts.mode === "array" ? (state) => {
      return [state.meta, Object.keys(state.value).length];
    } : void 0
  );
  useIsomorphicLayoutEffect(() => fieldApi.mount(), [fieldApi]);
  return fieldApi;
}
function Field({
  children,
  ...fieldOptions
}) {
  const fieldApi = useField(fieldOptions);
  return /* @__PURE__ */ React.createElement(
    formContext.Provider,
    {
      value: {
        formApi: fieldApi.form,
        parentFieldName: fieldApi.name
      },
      children: functionalUpdate(children, fieldApi)
    }
  );
}
export {
  Field,
  useField
};
//# sourceMappingURL=useField.js.map